import { AbilityBuilder } from '@casl/ability';
import { User } from '../modules/auth';
import { AppAbility, createAppAbility } from './appAbility';

type DefinePermissions = (
  user: User,
  builder: AbilityBuilder<AppAbility>,
) => void;
export type Roles = 'admin' | 'member';

const rolePermissions: Record<Roles, DefinePermissions> = {
  member() {},
  admin(user, { can }) {
    can('manage', 'all');
  },
};

export function defineAbilityFor(user: User): AppAbility {
  const builder = new AbilityBuilder(createAppAbility);

  let roleName: Roles = 'member';
  if (user.roleName === '1') roleName = 'admin';
  else if (user.roleName === '2') roleName = 'member';
  if (typeof rolePermissions[roleName] === 'function') {
    rolePermissions[roleName](user, builder);
  } else {
    throw new Error(`Trying to use unknown role "${user.roleName}"`);
  }

  return builder.build();
}
